import {XIcon} from '@heroicons/react/outline';
import {QuestionMarkCircleIcon} from '@heroicons/react/solid';
import styled from 'styled-components';
import {FlexFill, H6, StandardButton, Theme} from '../../../Components';
import {fadeInScale} from '../../../Components/Atoms/animations';
import {LegendWrapper, Panel} from './containers';

const PanelHeader = styled.div`
  flex-direction: row;
  flex: 0;
  padding: 20px 20px 0px;
`;

const PanelTopButton = styled.button`
  align-items: center;
  background: #ffffff;
  border: none;
  display: flex;
  flex-direction: row;
  height: 24px;
  justify-content: center;
  margin: 0;
  width: 24px;
  z-index: 10;
  &:hover {
    color: ${Theme.Colors.Oranges._000};
  }
`;

const PanelContent = styled.div`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 15px -3px rgba(106, 111, 123, 0.1), 0px 4px 6px -2px rgba(106, 111, 123, 0.05);

  animation: ${fadeInScale} 0.2s ease-out;
`;

const OpenButton = ({showButton, onOpenLegend}: {showButton: boolean; onOpenLegend: () => void}) =>
  showButton ? (
    <StandardButton id="open-legend" onClick={onOpenLegend} style={{transition: 'all 0.2s ease-in-out', width: 217}}>
      <QuestionMarkCircleIcon width={20} style={{marginBottom: -5, marginRight: 12}} />
      Open Legend
    </StandardButton>
  ) : (
    <></>
  );

export const LegendBlock = ({
  legendOpen,
  onCloseLegend,
  showButton,
  onOpenLegend,
  children,
}: {
  legendOpen: boolean;
  onCloseLegend: () => void;
  showButton: boolean;
  onOpenLegend: () => void;
  children: React.ReactNode;
}) => {
  return (
    <LegendWrapper id="map-legend">
      <Panel id="map-panel" style={{width: 320, background: 'transparent', alignItems: 'flex-end', overflow: 'hidden', padding: 10}}>
        {legendOpen ? (
          <PanelContent style={{overflow: 'hidden', maxHeight: 'calc(100vh - 120px)'}}>
            <PanelHeader>
              <H6 style={{color: Theme.Colors.Oranges._000}}>Legend</H6>
              <FlexFill />
              <PanelTopButton id="close-legend" data-html2canvas-ignore onClick={onCloseLegend}>
                <XIcon style={{width: 24, height: 24, flexShrink: 0}} />
              </PanelTopButton>
            </PanelHeader>
            <div style={{overflowY: 'auto', padding: 20}}>{children}</div>
          </PanelContent>
        ) : (
          <OpenButton showButton={showButton} onOpenLegend={onOpenLegend} />
        )}
      </Panel>
    </LegendWrapper>
  );
};
